import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql, withPrefix } from 'gatsby'
import { useLocalStorage, useSearchParam } from 'react-use'

import Box from '../../components/Box'
import Footer from '../Footer'


const Layout = ({ children, location }) => {
  const [info, setInfo, remove] = useLocalStorage('info')
  const [,,removeStep] = useLocalStorage('step')
  const [,,removeTest] = useLocalStorage('test')
  const [temple, setTemple] = useLocalStorage('temple')
  // const from = useSearchParam('utm_source');
  useEffect(() => {
    if (!info?.first) {
      setTemple(location?.pathname.split('/')[1])
      setInfo({ ...info, first: true })
    }
    window.onunload = window.onbeforeunload = function (e) {
      // if(typeof e=='undefined'){
      //  e=window.event;
      // }
      // For IE and Firefox prior to version 4
      // if (e) {
      //     e.returnValue = 'Sure?';
      // }
      // For Safari
      // console.log(window.retain)
      if(!window.do__not__remove) {
        remove()
        removeStep()
        removeTest()
        // removeTemple()
      }
      return
    }
  }, [])
  // console.log(temple)
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
              description
              siteUrl
            }
          }
        }
      `}
      render={({
        site: {
          siteMetadata: { title, description, siteUrl, fbTitle },
        },
      }) => {
        return (
          <>
            <Helmet>
              <html lang="zh-Hant-TW" />
              <title>{title}</title>
              <meta name="description" content={description} />
              <link
                rel="apple-touch-icon"
                sizes="180x180"
                href={withPrefix('/apple-touch-icon.png')}
              />
              <link
                rel="icon"
                type="image/png"
                sizes="32x32"
                href={withPrefix('/favicon-32x32.png')}
              />
              <link
                rel="icon"
                type="image/png"
                sizes="16x16"
                href={withPrefix('/favicon-16x16.png')}
              />
              <link
                rel="mask-icon"
                color="#5bbad"
                href={withPrefix('/safari-pinned-tab.svg')}
              />
              <meta name="msapplication-TileColor" content="#da532c" />
              <meta name="theme-color" content="#ffffff" />
              <meta property="og:url" content={siteUrl} />
              <meta property="og:title" content={fbTitle} />
              <meta property="og:description" content={description} />
              <meta property="og:image" content={`${siteUrl}/xiahai_fb.jpg`} />
            </Helmet>
            {/* {!hideHeader && <Header height={headerHeight} siteTitle={title} />} */}
            <Box as="main" bg="custom.primaryBg">
              {children}
            </Box>
            <Footer temple={temple} />
          </>
        )
      }}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
